import { ChatBubbleOvalLeftIcon, UserIcon } from "@heroicons/react/24/solid";
import { isoToFriendly } from "@moe/oss/utils/time";
import { Profile } from "@moe/priv/model/profile";
import { FollowModal } from "@web/components/FollowModal";
import { formatCount } from "@web/lib/utils";
import { useAppContext } from "@web/route-services/root/AppContext";
import { motion } from "motion/react";

interface BelowAvatarProps {
  profile: Profile;
}

export function BelowAvatar({ profile }: BelowAvatarProps) {
  const { createModal } = useAppContext();
  return (
    <div>
      <p className="text-tx-tertiary mb-1 text-center text-xs font-semibold md:text-sm">
        {`Since ${isoToFriendly(profile.createdAt)}`}
      </p>
      <div className="text-tx-tertiary flex flex-row items-center justify-center space-x-5 text-sm font-[600] ">
        <button
          className="flow-row flex items-center transition duration-200 ease-out hover:brightness-90 "
          onClick={() => {
            createModal({
              content: <FollowModal profile={profile} />
            });
          }}
        >
          <UserIcon className="size-5 md:size-6" />
          <span>{formatCount(profile.followerCount)}</span>
        </button>
        <div className="flex flex-row items-center justify-center space-x-1">
          <ChatBubbleOvalLeftIcon className="size-5 md:size-6" />
          <span className="mt-0.5">{formatCount(profile.messageCount)}</span>
        </div>
      </div>
    </div>
  );
}

export function BelowAvatarSkeleton() {
  return (
    <motion.div
      className="flex flex-col items-center space-y-2"
      initial={{ opacity: 0.7 }}
      animate={{ opacity: [0.7, 1, 0.7] }}
      transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
    >
      <div className="bg-muted h-4 w-32 rounded"></div>
      <div className="flex space-x-3">
        <div className="bg-muted h-5 w-12 rounded"></div>
        <div className="bg-muted h-5 w-12 rounded"></div>
      </div>
    </motion.div>
  );
}
